// @flow

//
// React
//
import React from 'react';

//
// Formatter
//
import { fmtQuantity } from '../../../../../lib/trix-web-data-commons';

//
// Cell renderer
//
import {
    createItemSubItemCellRenderer,
} from '../../../../../lib/trix-web-components-table';

const createPutawayItemQuantitiesTableColumn = (cfg: any): any => {
    return {
        align: 'right',
        flex: false,
        width: 120,

        renderCell: createItemSubItemCellRenderer({
            ...cfg.cellRendererFactoryProps,

            align: 'right',

            getItem: (props: any) => {
                return fmtQuantity((props.row && props.row.quantity) ? 
                        props.row.quantity : undefined);
            },

            getSubItem: (props: any) => {
                const putawayQuantity = (props.row && props.row.putawayQuantity) ? 
                    props.row.putawayQuantity : {
                        amount: 0.0, 
                        unit: '-'
                    };
                const cancelledQuantity = (props.row && props.row.cancelledQuantity) ? 
                    props.row.cancelledQuantity : {
                        amount: 0.0, 
                        unit: '-'
                    };

                return `${fmtQuantity(putawayQuantity)} (${fmtQuantity(cancelledQuantity)})`
            }
        })
    }
}
export default createPutawayItemQuantitiesTableColumn;